export default __webpack_public_path__ + "static/media/matilda_1.aabc5783.jpeg";